import { Component, OnInit, Inject, ViewChild, NgZone } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { environment } from '../../environments/environment';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Router } from "@angular/router";
import { SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';
import { DlgErrorComponent } from '../components/dlg-error/dlg-error.component';
import { DlgTrabajandoComponent } from '../components/dlg-trabajando/dlg-trabajando.component';
import { DlgPacientesModComponent } from '../components/dlg-pacientes-mod/dlg-pacientes-mod.component';
import { DlgBusquedasComponent } from '../components/dlg-busquedas/dlg-busquedas.component';
import { MatTableDataSource} from '@angular/material/table'
import { MatPaginator} from '@angular/material/paginator'
import { DlgEnviosComponent } from '../components/dlg-envios/dlg-envios.component';
import { DlgEnvioNotificacionComponent } from '../components/dlg-envio-notificacion/dlg-envio-notificacion.component';
import { DlgAvisoComponent } from '../components/dlg-aviso/dlg-aviso.component';

@Component({
  selector: 'app-principal',
  templateUrl: './principal.component.html',
  styleUrls: ['./principal.component.css']
})
export class PrincipalComponent implements OnInit {

  muestraTabPanelControl = true;
  muestraTabAtencion = true;
  muestraModulos = true;
  indiceTab = 1;
  muestraTabMensajes = true;
  displayedColumns: string[] = ['fechaCrea','consorcio','estado'];
  escondeFraseNoHay=false;
  dataSource = new MatTableDataSource();
  @ViewChild('paginador') paginador: MatPaginator;

  constructor(
    public dialog: MatDialog,
    private httpClient: HttpClient,
    private router: Router,
    @Inject(SESSION_STORAGE) private storage: StorageService,
    private ngZone: NgZone,
  ) {

  }

  ngOnInit(): void {
    this.leerEnvios();
  }

  

  cerrarDialogo(dialogoActual) {
    dialogoActual.close();
  }

  cambiaTab(indice) {
    this.indiceTab = indice;
    if (indice == 3) {
      this.leerEnvios();
    }
  }

  public buscar = (value: string) => {
    this.dataSource.filter = value.trim().toLocaleLowerCase();
  }

  modificarNotificacion(idNotificacion){
    let dlgEnvioMod = this.dialog.open(DlgEnvioNotificacionComponent, {
      width: '60vw',
      height:'90vh',
      disableClose:true
    });
    dlgEnvioMod.componentInstance.idActual=idNotificacion;
    dlgEnvioMod.afterClosed().subscribe(
        data => {
          if (data.mensaje=="almaceno"){
            this.leerEnvios();
          }
        }
    );
  }

  modificarEnvio(idEnvio){
    let dlgEnvioMod = this.dialog.open(DlgEnviosComponent, {
      width: '60vw',
      height:'90vh',
      disableClose:true
    });
    dlgEnvioMod.componentInstance.idActual=idEnvio;
    dlgEnvioMod.afterClosed().subscribe(
        data => {
          if (data.mensaje=="almaceno"){
            this.leerEnvios();
          }
        }
    );
  }

  leerEnvios() {
    let dlgTrabajando = this.dialog.open(DlgTrabajandoComponent, {
      width: '600px',
      disableClose: true
    });
    dlgTrabajando.componentInstance.titulo = "";
    dlgTrabajando.componentInstance.texto = "Buscando los envios";
    this.httpClient.get(environment.servidorHttp + 'Sistema/leerEnvios'
      , {
        params: {
          "idConexion": this.storage.get("idConexion")
        },
        headers: {
          "Authorization": 'Bearer ' + this.storage.get("token"),
        }
      })
      .subscribe(data => {
        this.cerrarDialogo(dlgTrabajando);
        if (data['resultado']['msgError']['valorDevuelto'] == "01") {
          let dlgError = this.dialog.open(DlgErrorComponent, {
            width: '600px',
            disableClose: true
          });
          dlgError.componentInstance.titulo = "Error al buscar los envios";
          dlgError.componentInstance.texto = data['resultado']['msgError']['mensaje'];
        } else {
          if (data['resultado']['datos'] == undefined) {
            this.escondeFraseNoHay = false;
            return;
          }
          else {
            this.escondeFraseNoHay = true;
            this.dataSource = new MatTableDataSource<any>(data['resultado']['datos']);
            this.dataSource.paginator = this.paginador;
            this.paginador._intl.itemsPerPageLabel = 'Envios por hoja';
            this.paginador._intl.nextPageLabel  = 'Proxima hoja';
            this.paginador._intl.previousPageLabel  = 'Hoja anterior';
            this.paginador._intl.lastPageLabel  = 'Última hoja';
            this.paginador._intl.firstPageLabel  = 'Primera hoja';
            this.paginador._intl.getRangeLabel = (page: number, pageSize: number, length: number) => {
              return 'De '+((page * pageSize) + 1) + ' a ' + ((page * pageSize) + pageSize) + ' de ' + length; 
            }
          }
        }
      },
        (error: HttpErrorResponse) => {
          this.cerrarDialogo(dlgTrabajando);
          let dlgError = this.dialog.open(DlgErrorComponent, {
            width: '600px',
            disableClose: true
          });
          if (error.status.toString() == "401") {
            dlgError.componentInstance.titulo = "Error al buscar los envios";
            dlgError.componentInstance.texto = "Su sesión ha finalizado";
            this.router.navigate(['/']);
          } else {
            dlgError.componentInstance.titulo = "Error al buscar los envios";
            dlgError.componentInstance.texto = error.message + " (" + error.status + ")";
          }
        });

  }
}


